import { ancestorsOf, type OrgTreeModel } from './org-tree'

/**
 * Reparenting rules shared by the Move to… dialog and drag-and-drop (TO-389
 * organization-admin-ui REQ-006, design §5). A unit may move under any unit that
 * is neither itself nor one of its descendants, or to the root (`null`). The
 * server still enforces type, status and existence rules.
 */
export function isLegalMoveTarget(model: OrgTreeModel, unitId: string, targetId: string | null): boolean {
	if (targetId === null) return true
	if (targetId === unitId) return false
	return !ancestorsOf(model, targetId).includes(unitId)
}

/** Every unit the picker may offer for `unitId`: all units minus its subtree. */
export function moveTargetIds(model: OrgTreeModel, unitId: string): string[] {
	const excluded = new Set<string>([unitId])
	const stack = [...(model.children.get(unitId) ?? [])]
	while (stack.length > 0) {
		const id = stack.pop() as string
		excluded.add(id)
		stack.push(...(model.children.get(id) ?? []))
	}
	return [...model.byId.keys()].filter((id) => !excluded.has(id))
}
